import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Countries from './components/Countries';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import { Toaster } from './components/ui/sonner';
import { LanguageProvider } from './i18n';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <Header />
        <main>
          <Hero />
          <Services />
          <Countries />
          <About />
          <Portfolio />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster position="top-center" richColors />
      </LanguageProvider>
    </div>
  );
}

export default App;
